import { Partial } from '@40seas/entities/common';
import { CreateCreditSafeReportDto } from './create.credit-safe.report.dto';

export class UpdateCreditSafeReportDto extends Partial(CreateCreditSafeReportDto) {}
